module.exports = __webpack_public_path__ + "static/turtle-creek-house47-855781fba51acac9ab0b6d271ea6da4f.jpg";